import { Classes } from "@blueprintjs/core"
import React from "react"
import classNames from "utils/classNames"
import CustomPopover, { CustomPopoverProps } from "./CustomPopover"

type CustomPopoverAbsoluteProps = CustomPopoverProps & {
  /**
   * Sets the positioning of the popoverContent to absolute
   * (useful when inside dialogs and overlays)
   * @default false
   */
  absolute?: boolean
}
const CustomPopoverAbsolute = ({
  absolute,
  className,
  children,
  ...otherProps
}: CustomPopoverAbsoluteProps) => {
  return (
    <CustomPopover
      {...otherProps}
      className={className && `${className}-wrapper`}
      popoverClassName={classNames(
        "vt-custom-popover",
        {
          absolute: absolute,
          [Classes.ELEVATION_1]: absolute,
        },
        className
      )}
    >
      {children}
    </CustomPopover>
  )
}

export default CustomPopoverAbsolute
